/* eslint-disable quotes */
import type { Color, ColorContrast, ColorMeteor, ColorSchema, Theme } from "themes/interfaces";
import { BaseBorder, BaseColor, BaseComponent, BaseFont, BaseSpacing } from "themes/base";
import { Enums } from "utils";

export const Dark: Theme = {
  id: Enums.EnumTheme.Dark,
  font: BaseFont,
  color: {
    ...BaseColor,
    theme: { color: "#23262f", accent: "#2e3037", text: "#f0f0f9" } as ColorSchema,
    border: { color: "#434651", accent: "#747782" } as ColorContrast,
    shadow: { color: "2px 2px 0px 0px #111217", accent: "4px 4px 0px 0px #000000" } as ColorContrast,
    input: { color: "#191b22", accent: "#434651" } as ColorSchema,
    font: { color: "#f0f0f9", accent: "#c4c6d3" } as ColorContrast,
    background: { color: "#13141a", accent: "#191b22", textAccent: "#c4c6d3" } as ColorSchema,
    primary: { color: "#b1c5ff", accent: "#5072c2", text: "#001946", textAccent: "#dae2ff" } as ColorSchema,
    accent: { color: "#b1c5ff", accent: "#dae2ff", text: "#001946" } as ColorSchema,
    secondary: { color: "#ffb4a5", accent: "#954838", text: "#3d0601" } as ColorSchema,
    disabled: { color: "#2e3037", text: "#747782" } as ColorSchema,
    meteor: {
      head: "#ffffff",
      glow: "rgba(255, 255, 255, 0.85)",
      tail: "linear-gradient(to left, rgba(255,255,255,0.85), rgba(177,197,255,0.3) 20%, transparent 100%)",
    } as ColorMeteor,
  } as Color,
  border: BaseBorder,
  spacing: BaseSpacing,
  component: BaseComponent,
};
